import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-organization-successfully',
  templateUrl: './organization-successfully.component.html',
  styleUrls: ['./organization-successfully.component.scss']
})
export class OrganizationSuccessfullyComponent implements OnInit {
  adminData: any;
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
  }
  logout() {
   // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
}
